import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const ManageDateFormatViewChunk = lazy(() =>
  import('../feature-sets/ManageDateFormatView').then(
    ({ ManageDateFormatView }) => ({
      default: ManageDateFormatView,
    })
  )
)

export const ManageDateFormatPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageDateFormatTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.manageDateFormatTitle),
          escapeCaseFormatting: true,
        },
      ]}
    >
      <ManageDateFormatViewChunk />
    </Page>
  )
}
